module.exports = __webpack_public_path__ + "img/1547506979.8ad24b81.jpg";